<!--@if (product) {-->
    <div class="flex flex-col gap-5">
<!--        <div class="">-->
<!--            <app-input-->
<!--                    type="email"-->
<!--                    [label]="'email' | translate"-->
<!--                    [labelClass]="'!text-start'"-->
<!--                    [formControlItem]="form.get('email')"-->
<!--                    [customClasses] = "'!h-10'"-->
<!--                    [placeholder]="'enter_value' | translate: {value:('email'| translate)}">-->
<!--                >-->
<!--            </app-input>-->
<!--        </div>-->
        <div class="mt-10">
            <app-topup-new-component
                    [withoutPackage] = "true"
                    [withoutUser] = "true"
                    (changePaymentMethode)="changePaymentMethode($event)"
                    (finishPayment)="finishPayment($event)"
                    [selectedPayment]="selectedPaymentMethode"
                    [selectedData] = "paymentData"
                    (startPaymentLoading)= "paymentLoadingTrigger(true)"
                    (endPaymentLoading)= "paymentLoadingTrigger(false)"
            ></app-topup-new-component>
        </div>

        <div class=" flex flex-col gap-2">
            <white-label-toggle [label]="'covering_service_fee_text' | translate" (onChange)="coveringServiceFee($event)"></white-label-toggle>
            <span class="self-center"> {{'total_amount' | translate}} {{ (amount )| currency: form.get('currency')?.value }} </span>

            <a
                    (click)="donate()"
                    class=" flex w-full items-center justify-center rounded-md border border-transparent bg-primary px-8 py-3 text-base font-medium text-normal hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary cursor-pointer"
                    [class.opacity-50]="paymentLoading"
                    [class.pointer-events-none]="paymentLoading"
            >
                <ng-container *ngIf="!paymentLoading"> {{ 'donate'| translate }}</ng-container>
                <ng-container *ngIf="paymentLoading">
                    <svg class="w-6 h-6 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                </ng-container>
            </a>
        </div>
    </div>
<!--}-->
